import { render, staticRenderFns } from "./CouponManagementItem.vue?vue&type=template&id=8b9f8692"
import script from "./CouponManagementItem.vue?vue&type=script&lang=js"
export * from "./CouponManagementItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports